const CartItemSkeleton = () => {
    return (
        <div className="flex gap-4 bg-white p-3 border border-gray-100 rounded-2xl shadow-sm relative overflow-hidden">
            {/* Shimmer overlay */}
            <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/50 to-transparent"></div>
            
            {/* Image Skeleton */}
            <div className="relative w-24 h-24 flex-shrink-0 overflow-hidden rounded-xl bg-gray-100 self-center"></div>

            {/* Content Skeleton */}
            <div className="flex flex-col flex-grow justify-between py-0.5 overflow-hidden w-full space-y-2">

                {/* Top Row */}
                <div className="flex justify-between items-start gap-2">
                    <div className="min-w-0 flex-grow space-y-2">
                        <div className="h-4 bg-gray-200 rounded-md w-3/4"></div>
                        <div className="h-3 bg-gray-200 rounded-md w-1/2"></div>
                    </div>
                    <div className="w-6 h-6 bg-gray-200 rounded-md"></div>
                </div>

                {/* Bottom Row */}
                <div className="flex justify-between items-end mt-2">
                    <div className="flex items-center bg-gray-100 rounded-lg h-8 w-24">
                        <div className="w-8 h-full bg-gray-200 rounded-l-lg"></div>
                        <div className="w-6 h-4 bg-gray-200 mx-1 rounded"></div>
                        <div className="w-8 h-full bg-gray-200 rounded-r-lg"></div>
                    </div>

                    <div className="flex flex-col items-end space-y-1">
                        <div className="h-3 bg-gray-200 rounded-md w-20"></div>
                        <div className="h-5 bg-gray-200 rounded-md w-16"></div>
                    </div>
                </div>
            </div>

            {/* Add this CSS to your global styles or style tag */}
            <style jsx>{`
                @keyframes shimmer {
                    0% {
                        transform: translateX(-100%);
                    }
                    100% {
                        transform: translateX(100%);
                    }
                }
            `}</style>
        </div>
    );
};

export default CartItemSkeleton;